import { Modal, DatePicker, Input, Message } from '@bitcine/cinesend-theme'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { indefiniteEndDate, indefiniteStartDate } from '../../constants/dates'

const titleMap = {
  categories: 'Create Section',
  'ad-pools': 'Create Ad Pool',
  assets: 'Create Assets Category',
  'warning-slates': 'Create Warning Slate Group',
}

const CreateForm = ({ isOpen, onClose, cycleID, createModel, categoryType, onSuccess }) => {
  const [startDate, setStartDate] = useState(categoryType === 'warning-slates' ? indefiniteStartDate : null)
  const [endDate, setEndDate] = useState(categoryType === 'warning-slates' ? indefiniteEndDate : null)
  const [title, setTitle] = useState('')
  const [externalUniqueName, setExternalUniqueName] = useState('')
  const [externalNameTouched, setExternalNameTouched] = useState(false)
  const [hasNameConflict, setHasNameConflict] = useState(false)

  const navigate = useNavigate()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={titleMap[categoryType]}
      confirmButton={{
        text: 'Create',
        disabled:
          (categoryType !== 'warning-slates' && categoryType !== 'categories' && (!startDate || !endDate)) ||
          !title ||
          (categoryType !== 'warning-slates' && externalNameTouched && !externalUniqueName) ||
          createModel.isLoading,
        onClick: () =>
          createModel.mutate(
            {
              endpoint: 'categories',
              data: {
                title,
                type: categoryType,
                cycle_id: cycleID,
                is_root: categoryType === 'categories',
                ...(categoryType !== 'categories' ? { start_date: startDate, end_date: endDate } : {}),
                ...(categoryType !== 'warning-slates'
                  ? { external_unique_name: externalNameTouched ? externalUniqueName : title }
                  : {}),
              },
            },
            {
              onSuccess: (res) => (onSuccess ? onSuccess(res) : navigate(`${res.data.category.id}/details`)),
              onError: (err) => {
                if (err.response?.data?.errors?.external_unique_name) {
                  setHasNameConflict(true)
                }
              },
            }
          ),
      }}
    >
      <div className='space-y-2'>
        <Input
          label={'Title'}
          value={title}
          onChange={(e) => {
            setTitle(e.target.value)
            if (hasNameConflict) setHasNameConflict(false)
          }}
        />
        {categoryType !== 'warning-slates' && (
          <div>
            <Input
              label={'External Unique Name'}
              description={
                'A stable identifier used to match this category across cycles and systems. ' +
                'It must be unique per airline — if the same name is used for different content types (e.g. Movies, TV Series), append the content type to distinguish them. ' +
                'Only admin users can edit this field after a snapshot has been successfully generated for this cycle.'
              }
              value={externalNameTouched ? externalUniqueName : title}
              onChange={(e) => {
                setExternalUniqueName(e.target.value)
                setExternalNameTouched(true)
                if (hasNameConflict) setHasNameConflict(false)
              }}
            />
            {hasNameConflict && (
              <Message error={true} small={true}>
                This name is already in use by another category for this airline. Try appending the content type (e.g.
                &quot;Movies (TV Series)&quot;) to make it unique.
              </Message>
            )}
          </div>
        )}
        {categoryType !== 'warning-slates' && categoryType !== 'categories' && (
          <>
            <DatePicker
              useLocal={false}
              label={'Start Date'}
              className='w-full'
              date={startDate}
              showTimeSelect={false}
              onChange={(newDate) => setStartDate(newDate)}
            />
            <DatePicker
              useLocal={false}
              label={'End Date'}
              className='w-full'
              date={endDate}
              showTimeSelect={false}
              onChange={(newDate) => setEndDate(newDate)}
            />
          </>
        )}
      </div>
    </Modal>
  )
}

export default CreateForm
